// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__pa8P8","buttons":"SendReceipts_buttons__1i3Ku","email":"SendReceipts_email__2ApP2","bookApptTitle":"SendReceipts_bookApptTitle__1s52g"};